<template>
<form @submit.prevent="login">
  <div>
    <label for="email">Email</label>
    <input
      id="email"
      type="email"
      v-model="email"
      required
      placeholder="Enter your email"
    />
  </div>
  <div>
    <label for="password">Password</label>
    <input
      id="password"
      type="password"
      v-model="password"
      required
      placeholder="Enter your password"
    />
  </div>
  <button type="submit" :disabled="loading">
    {{ loading ? 'Logging in...' : 'Login' }}
  </button>
</form>
</template>
<style lang="scss">


</style>

<script>

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    login() {
      this.$emit('login', { email: this.email, password: this.password });
    },
  },
};
</script>
